export default __webpack_public_path__ + "static/media/Fun.4fd5a9b1.png";